// AUTO-GENERATED by vite-plugin-tool-discovery — do not edit
import type { ToolManifest } from '@/types/tool-manifest';

import CashCountCategoryMaintenance from '@/tools/cash-count-category-maintenance/manifest.json';
import CashCountManagement from '@/tools/CashCountManagement/manifest.json';
import CashierManagement from '@/tools/CashierManagement/manifest.json';
import ComboBoxMaintenance from '@/tools/ComboBoxMaintenance/manifest.json';
import CurrencyBagManagement from '@/tools/CurrencyBagManagement/manifest.json';
import DepartmentMaintenance from '@/tools/DepartmentMaintenance/manifest.json';
import DepositCategoryMaintenance from '@/tools/DepositCategoryMaintenance/manifest.json';
import DepositCategoryTypeMaintenance from '@/tools/DepositCategoryTypeMaintenance/manifest.json';
import DocumentDesigner from '@/tools/DocumentDesigner/manifest.json';
import DocumentTypes from '@/tools/DocumentTypes/manifest.json';
import DropAndIssue from '@/tools/DropAndIssue/manifest.json';
import EmployeeMaintenance from '@/tools/EmployeeMaintenance/manifest.json';
import GameDays from '@/tools/GameDays/manifest.json';
import GLAccountCodeMaintenance from '@/tools/GLAccountCodeMaintenance/manifest.json';
import GLMapping from '@/tools/GLMapping/manifest.json';
import Home from '@/tools/Home/manifest.json';
import MachineCountManagement from '@/tools/MachineCountManagement/manifest.json';
import MachineTool from '@/tools/machine-settings/manifest.json';
import MyCashierManagement from '@/tools/MyCashierManagement/manifest.json';
import RevenueCenterMaintenance from '@/tools/RevenueCenterMaintenance/manifest.json';
import RoleMaintenanceTool from '@/tools/RoleMaintenanceTool/manifest.json';
import SecurityControls from '@/tools/SecurityControls/manifest.json';
import SystemOptions from '@/tools/SystemOptions/manifest.json';
import TableCountManagement from '@/tools/TableCountManagement/manifest.json';
import TaskStatusMaintenance from '@/tools/TaskStatusMaintenance/manifest.json';
import TaskTypeMaintenance from '@/tools/TaskTypeMaintenance/manifest.json';
import TicketTypeMaintenance from '@/tools/TicketTypeMaintenance/manifest.json';
import TipEmployeeManagement from '@/tools/TipEmployeeManagement/manifest.json';
import TipPoolMaintenance from '@/tools/TipPoolMaintenance/manifest.json';
import TransactionTypeMaintenance from '@/tools/TransactionTypeMaintenance/manifest.json';
import VaultLocationMaintenance from '@/tools/VaultLocationMaintenance/manifest.json';
import VaultManagement from '@/tools/VaultManagement/manifest.json';

export const manifestIndex: Record<string, ToolManifest> = {
  CashCountCategoryMaintenance: CashCountCategoryMaintenance as ToolManifest,
  CashCountManagement: CashCountManagement as ToolManifest,
  CashierManagement: CashierManagement as ToolManifest,
  ComboBoxMaintenance: ComboBoxMaintenance as ToolManifest,
  CurrencyBagManagement: CurrencyBagManagement as ToolManifest,
  DepartmentMaintenance: DepartmentMaintenance as ToolManifest,
  DepositCategoryMaintenance: DepositCategoryMaintenance as ToolManifest,
  DepositCategoryTypeMaintenance: DepositCategoryTypeMaintenance as ToolManifest,
  DocumentDesigner: DocumentDesigner as ToolManifest,
  DocumentTypes: DocumentTypes as ToolManifest,
  DropAndIssue: DropAndIssue as ToolManifest,
  EmployeeMaintenance: EmployeeMaintenance as ToolManifest,
  GameDays: GameDays as ToolManifest,
  GLAccountCodeMaintenance: GLAccountCodeMaintenance as ToolManifest,
  GLMapping: GLMapping as ToolManifest,
  Home: Home as ToolManifest,
  MachineCountManagement: MachineCountManagement as ToolManifest,
  MachineTool: MachineTool as ToolManifest,
  MyCashierManagement: MyCashierManagement as ToolManifest,
  RevenueCenterMaintenance: RevenueCenterMaintenance as ToolManifest,
  RoleMaintenanceTool: RoleMaintenanceTool as ToolManifest,
  SecurityControls: SecurityControls as ToolManifest,
  SystemOptions: SystemOptions as ToolManifest,
  TableCountManagement: TableCountManagement as ToolManifest,
  TaskStatusMaintenance: TaskStatusMaintenance as ToolManifest,
  TaskTypeMaintenance: TaskTypeMaintenance as ToolManifest,
  TicketTypeMaintenance: TicketTypeMaintenance as ToolManifest,
  TipEmployeeManagement: TipEmployeeManagement as ToolManifest,
  TipPoolMaintenance: TipPoolMaintenance as ToolManifest,
  TransactionTypeMaintenance: TransactionTypeMaintenance as ToolManifest,
  VaultLocationMaintenance: VaultLocationMaintenance as ToolManifest,
  VaultManagement: VaultManagement as ToolManifest,
};
